import { hash } from "lib/hash";
import React, { FC } from "react";

type ScriptData = {
    id: string;
    hash: string;
    type: "include" | "inline";
    src?: string;
    content?: string;
};

let scriptsList: ScriptData[] = [];

type Props = {
    src: string;
    id: string;
};

// TODO: why is this a component?
export const Script: FC<Props> = ({ src, id, children }) => {
    const content = `/*{literal}<![CDATA[*/${
        children?.toString ? children.toString() : ""
    }/*]]>{/literal}*/`;

    const script: ScriptData = src
        ? { hash: hash(src), type: "include", src, id }
        : { hash: hash(content), type: "inline", content, id };

    // If an id is given then delete the script with that id, else fill the id with the hash
    if (id) {
        scriptsList.splice(
            scriptsList.findIndex((x) => x.id === id),
            1
        );
    } else {
        script.id = script.hash;
    }

    // If the script isn't already in the scriptsList then add it
    if (scriptsList.every((s) => s.hash !== script.hash)) {
        scriptsList = [...scriptsList, script];
    }

    return null;
};

const InlineScript: FC<{ spec: ScriptData }> = ({ spec }) => {
    return (
        <script
            dangerouslySetInnerHTML={{ __html: spec.content || "" }}
            data-hash={spec.hash}
            data-id={spec.id}
            async
        />
    );
};

const ExternalScript: FC<{ spec: ScriptData }> = ({ spec }) => {
    return <script async src={spec.src} data-hash={spec.hash} data-id={spec.id} />;
};

const scriptTypeMap = {
    include: ExternalScript,
    inline: InlineScript
};

// scriptlist needs to be cleared because otherwise all possible scripts will show up on all pages
export const Scripts = (): (JSX.Element | null)[] => {
    const returnValue = scriptsList.map((script) => {
        const Component = scriptTypeMap[script.type];

        if (!Component) {
            return null;
        }

        return <Component key={script.hash} spec={script} />;
    });

    scriptsList = [];
    return returnValue;
};
